import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const Collection4Video = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/2yl2dgzjrb`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection4Video;
